var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Slash = function Slash(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 12c0-1.846.635-3.542 1.688-4.897l11.209 11.209A7.948 7.948 0 0 1 12 20c-4.411 0-8-3.589-8-8Zm16 0a7.954 7.954 0 0 1-1.688 4.897L7.103 5.688A7.948 7.948 0 0 1 12 4c4.411 0 8 3.589 8 8ZM12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Slash;